<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">The user can select the column names from the existing list of columns.</div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="closeModal()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <section>
                    <div class="col-md-4">
                        <input type="checkbox" (change)="onSelectAll($event)">
                        <label class="form-label p-1" for="Select All the Columns">
                            Select All the Columns
                        </label>
                    </div>
                    <div class="row mb-2" *ngIf="allReportColumns?.length">
                        <div class="col-md-4" *ngFor="let column Of allReportColumns;">
                            <input type="checkbox" [checked]="column.ischecked" (change)="onCheckBoxChange($event, column)">
                            <label class="form-label p-1" for="column.headerName">
                                {{column.headerName}}
                            </label>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-primary mx-2" (click)="bsModalRef.hide()">Cancel</button>
        <button class="btn btn-primary text-white mx-2" (click)="closeModal()"
            [disabled]="!filteredColumns.length">Apply</button>
    </div>
</section>